module.exports = __webpack_public_path__ + "static/media/2017_conf_Everything_is_a_Product.f36abac0.png";